import { IInvoice } from '../../interfaces/invoice.interface';

export class LoadInvoice {
  static type = '[Invoice] Load Invoice';

  constructor(public id: string, public isCacheEnabled: boolean = true) {}
}

export class ClearInvoice {
  static type = '[Invoice] Clear Invoice';
}

export class UpdateCurrentInvoice {
  static type = '[Invoice] Update Current Invoice';

  constructor(public invoice: IInvoice) {}
}

export class MarkAsFavorite {
  static type = '[Invoice] Mark As Favorite';

  constructor(public invoiceId: string) {}
}

export class SmartBanner {
  static type = '[Invoice] Smart Banner';

  constructor(public invoiceId: string) {}
}
